export const civicApiKey = process.env.CIVIC_API_KEY;

export const appleStoreAppUrl =
  "https://apps.apple.com/us/app/rnib-eyeware/id6621244084";

export const androidStoreAppUrl =
  "https://play.google.com/store/apps/details?id=com.rnibcharity.eyeware2";
